export class InsurancePaymentRate {
    id = null;
    voided = null;
    paymentTypeRate = null;
    paymentType = null;
    service = null;
    serviceId = null;
}